

import { createSlice } from "@reduxjs/toolkit";
import jsonData from './jsonData.json'


const jsonPrices = {

            "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood": {
                "id": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
                "type": "buyPrice",
                "price": "0.010982"
            }
        

}
const history = {"h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood":{
    "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
    "solPrice": 200.8411145,
    "sellPrice_Sol": 0.005023895406137073593,
    "sellPrice_Usd": 0.08023895406137073593,
    "totalAmount_Sol": 0.004438799238745441,
    "totalAmount_Usd": 0.8914933861513861,
    "totalFees": 0.000136138,
    "totalProfits_Usd": 150,
    "totalProfits_Sol": 0.9,
    "netProfits_Sol": 0.889,
    "netProfits_Usd": 149,
    "priceDollar": 0.005405944,
    "buyPriceInSol": 0.000002691652049556004,
    "tx_link": "https://solscan.io/tx/2mCnPr25NKg5yQtviAcdvTpLEMUjYsiGM98AjHB9ZPEcz4h33jbuHdfDfEurqr3WNoPQdzp71wdg3xCDDA5zJoGp",
    "postBalance": {
        "accountIndex": 13,
        "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
        "owner": "wPJLcdPGZVy5GRSQWW3qF7DYsaQrj3AmRG5TUyuTyPi",
        "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "uiTokenAmount": {
            "amount": "0",
            "decimals": 6,
            "uiAmount": null,
            "uiAmountString": "0"
        }
    },
    "signature": "2mCnPr25NKg5yQtviAcdvTpLEMUjYsiGM98AjHB9ZPEcz4h33jbuHdfDfEurqr3WNoPQdzp71wdg3xCDDA5zJoGp",
    "token_amount": 1857.595227,
    "blockTime": 1739110185,
    "slot": 319523053,
    "computeUnitsConsumed": 39580,
    "postTokenBalances": [
        {
            "accountIndex": 5,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "1095593753366673",
                "decimals": 6,
                "uiAmount": 1095593753.366673,
                "uiAmountString": "1095593753.366673"
            }
        },
        {
            "accountIndex": 6,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "2941378426835",
                "decimals": 9,
                "uiAmount": 2941.378426835,
                "uiAmountString": "2941.378426835"
            }
        },
        {
            "accountIndex": 11,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "BSfp5FVHwV6dvyQFvJ6g8EwWdYgKWdD1Krpi75vNKSgz",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "0",
                "decimals": 6,
                "uiAmount": null,
                "uiAmountString": "0"
            }
        },
        {
            "accountIndex": 12,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "BSfp5FVHwV6dvyQFvJ6g8EwWdYgKWdD1Krpi75vNKSgz",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "0",
                "decimals": 9,
                "uiAmount": null,
                "uiAmountString": "0"
            }
        },
        {
            "accountIndex": 13,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "wPJLcdPGZVy5GRSQWW3qF7DYsaQrj3AmRG5TUyuTyPi",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "0",
                "decimals": 6,
                "uiAmount": null,
                "uiAmountString": "0"
            }
        }
    ],
    "preTokenBalances": [
        {
            "accountIndex": 5,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "1095591895771446",
                "decimals": 6,
                "uiAmount": 1095591895.771446,
                "uiAmountString": "1095591895.771446"
            }
        },
        {
            "accountIndex": 6,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "2941383401525",
                "decimals": 9,
                "uiAmount": 2941.383401525,
                "uiAmountString": "2941.383401525"
            }
        },
        {
            "accountIndex": 11,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "BSfp5FVHwV6dvyQFvJ6g8EwWdYgKWdD1Krpi75vNKSgz",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "0",
                "decimals": 6,
                "uiAmount": null,
                "uiAmountString": "0"
            }
        },
        {
            "accountIndex": 12,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "BSfp5FVHwV6dvyQFvJ6g8EwWdYgKWdD1Krpi75vNKSgz",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "0",
                "decimals": 9,
                "uiAmount": null,
                "uiAmountString": "0"
            }
        },
        {
            "accountIndex": 13,
            "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
            "owner": "wPJLcdPGZVy5GRSQWW3qF7DYsaQrj3AmRG5TUyuTyPi",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "1857595227",
                "decimals": 6,
                "uiAmount": 1857.595227,
                "uiAmountString": "1857.595227"
            }
        }
    ],
    "fees": {
        "buyFees": 79323,
        "sellFees": 56815
    },
    "error": null
}
}


const testtrade ={ 
    "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood": {
        "takeProfit":0.00014956065584928295,
        'stopLoss':0.000001 ,
    "mint": "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood",
    "tx_link": "https://solscan.io/tx/2dxJ3nUqiurVcf3fdVsyLyNnYqu54fiQrmaC3DK6gQxuW3YTMJ79vgPHQKrYTYUdQ5Pc8qCrj3C2TdanJvkkC5sR",
    "buyPriceInSol": 0.0000037576877665049633,
    "priceDollar": 0.0007197049721343122,
    "postBalance": {
        "accountIndex": 3,
        "mint": "8B3ahBRnayaPEv6wqaVGWXzz5mAJmxLthteQLgeWpump",
        "owner": "wPJLcdPGZVy5GRSQWW3qF7DYsaQrj3AmRG5TUyuTyPi",
        "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "uiTokenAmount": {
            "amount": "13306054975",
            "decimals": 6,
            "uiAmount": 13306.054975,
            "uiAmountString": "13306.054975"
        }
    },
    "signature": "2dxJ3nUqiurVcf3fdVsyLyNnYqu54fiQrmaC3DK6gQxuW3YTMJ79vgPHQKrYTYUdQ5Pc8qCrj3C2TdanJvkkC5sR",
    "token_amount": 13306.054975,
    "blockTime": 1739466669,
    "slot": 320422561,
    "computeUnitsConsumed": 149205,
    "postTokenBalances": [
        {
            "accountIndex": 3,
            "mint": "8B3ahBRnayaPEv6wqaVGWXzz5mAJmxLthteQLgeWpump",
            "owner": "wPJLcdPGZVy5GRSQWW3qF7DYsaQrj3AmRG5TUyuTyPi",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "13306054975",
                "decimals": 6,
                "uiAmount": 13306.054975,
                "uiAmountString": "13306.054975"
            }
        },
        {
            "accountIndex": 6,
            "mint": "8B3ahBRnayaPEv6wqaVGWXzz5mAJmxLthteQLgeWpump",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "189431316442604",
                "decimals": 6,
                "uiAmount": 189431316.442604,
                "uiAmountString": "189431316.442604"
            }
        },
        {
            "accountIndex": 7,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "710094181000",
                "decimals": 9,
                "uiAmount": 710.094181,
                "uiAmountString": "710.094181"
            }
        }
    ],
    "preTokenBalances": [
        {
            "accountIndex": 6,
            "mint": "8B3ahBRnayaPEv6wqaVGWXzz5mAJmxLthteQLgeWpump",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "189444622497579",
                "decimals": 6,
                "uiAmount": 189444622.497579,
                "uiAmountString": "189444622.497579"
            }
        },
        {
            "accountIndex": 7,
            "mint": "So11111111111111111111111111111111111111112",
            "owner": "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1",
            "programId": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
            "uiTokenAmount": {
                "amount": "710044181000",
                "decimals": 9,
                "uiAmount": 710.044181,
                "uiAmountString": "710.044181"
            }
        }
    ],
    "fee": 74023,
    "error": null
}}

const initialState = {
    analytics:{
        winningTrades:1,
        loosingTrades:0,
        totalProfits:0.9
    },
    tradingStarted: false,
    userData: {},
    settings: {},
    pools: {},
    trades:testtrade,
    tradingHistory:history,
    realTimePrices: jsonPrices,
    newPools:null, // tx signature of new created pools 
    raydiumBotStarted:false,
    raydiumBotSettings:{amount:0.12,address:null,privateKey:null , maxOpenTrades:1 , tradingStarted:false , raydiumBotStarted:false},
    temporaryTrades:{},
    deletedRaydiumTemp:{'trade':{name:'hello'}}
}

export const RaydiumBotSlice = createSlice({
    name: 'raydiumBot',
    initialState: initialState,
    reducers: {
        
        setAnalytics: (state, action) => {state.analytics = {...state.analytics ,...action?.payload}},
        setAmount: (state, action) => {state.raydiumBotSettings = {...state.raydiumBotSettings ,amount:action?.payload}},
        addDeletedTemp: (state, action) => {state.deletedTemp = {...state.deletedRaydiumTemp , ...action?.payload}},
        setraydiumBotStarted: (state, action) => {state.raydiumBotSettings.raydiumBotStarted = action.payload},
        setTemporaryTrades: (state, action) => {state.temporaryTrades = action.payload},
        setNewPLiquidityools: (state, action) => {state.newPools = action.payload},
        setRaydiumUser: (state, action) => {state.userData = action.payload},
        setRaydiumSettings: (state, action) => {state.settings = action.payload},
        setRaydiumPools: (state, action) => {state.pools = { ...state.pools, ...action.payload }},
        RemoveRaydiumPool: (state, action) => {
            if (state.pools[action.payload]) {
                delete state.pools[action.payload]
            }},
        setRaydiumHistory: (state, action) => {
            state.tradingHistory = {...state.tradingHistory,...action.payload}},
        AddRaydiumTrade: (state, action) => {
            state.trades = { ...state.trades, ...action.payload }},
        RemoveRaydiumTrade: (state, action) => {
            delete state.trades[action.payload]
        },
        setTradingStarted: (state, action) => {
            state.tradingStarted = (action.payload)
        },
        updatePoolMetadata: (state, action) => {
            if (state.pools[action.payload.mint]) {
                state.pools = {
                    ...state.pools,
                    [action.payload.mint]: {
                        ...state.pools[action.payload.mint],
                        metadata: {
                            ...action.payload.metadata
                        }
                    }
                }
            }
        },
        updateRealTimePrices: (state, action) => {
            state.realTimePrices = {...state.realTimePrices , ...action.payload}
        },

    }
})

export const selectRealtimePrices = (state) => state.raydiumBot.realTimePrices
export const selectRaydiumTrades = (state) => state.raydiumBot.trades
export const selectRaydiumHistory = (state) => state.raydiumBot.tradingHistory
export const selectRaydiumPools = (state) => state.raydiumBot.pools
export const selectIsStarted = (state) => state.raydiumBot.tradingStarted
export const selectNewPoolAddress = (state) => state.raydiumBot.newPools
export const selectRaydiumBotSettings = (state) => state.raydiumBot.raydiumBotSettings
export const selectRaydiumAnalytics = (state) => state.raydiumBot.analytics

export const selectRaydiumDeletedTemp = (state) => state.raydiumBot.deletedRaydiumTemp


export const {
    setRaydiumUser,
    setRaydiumSettings,
    setRaydiumPools,
    setRaydiumHistory,
    AddRaydiumTrade,
    RemoveRaydiumTrade,
    RemoveRaydiumPool,
    setTradingStarted,
    updatePoolMetadata,
    updateRealTimePrices,
    setNewPLiquidityools,
    setraydiumBotStarted,
    addDeletedTemp,
    setAmount,
    setAnalytics
} = RaydiumBotSlice.actions


